// Version: 1.0
// v1.0: One button for the whole portal (CV-49). Every button has the same
//       8px corner (pills are for read-only status tags only), one of four
//       variants and one of three sizes. Pages pass layout (margin, width) in
//       style if they must, never radius, padding or font size: those come
//       from index.css, and check-buttons.js lists any page that sets
//       them on a button.
//
//   <Button variant="primary" onClick={save}>Save</Button>
//   <Button size="sm" onClick={raise}>Raise ticket</Button>
//   <Button variant="danger" solid onClick={confirmDelete}>Yes, delete</Button>
//   <Button variant="quiet" icon title="Close" onClick={close}>×</Button>
//   <Button size="sm" pressed={days === 30} onClick={() => setDays(30)}>30 days</Button>
//
//   variant: primary | secondary (default) | danger | quiet
//   size:    sm (28px) | md (34px, default) | lg (40px)
//   icon:    square, for a single symbol
//   block:   full width
//   pressed: true/false for toggles and filters (sets aria-pressed)
//   solid:   filled red, for the confirm step of a danger action

export function btnClass({ variant = 'secondary', size = 'md', icon = false, block = false, solid = false } = {}) {
  return ['btn', `btn-${variant}`,
          size !== 'md' && `btn-${size}`,
          icon && 'btn-icon',
          block && 'btn-block',
          solid && 'btn-solid'].filter(Boolean).join(' ');
}

export default function Button({ variant, size, icon, block, solid, pressed,
                                 className = '', type = 'button', ...rest }) {
  const cls = btnClass({ variant, size, icon, block, solid }) + (className ? ` ${className}` : '');
  return <button type={type} className={cls}
                 aria-pressed={pressed === undefined ? undefined : !!pressed} {...rest} />;
}
